<template>
  <div class="portrait_item" @click="isShow = !isShow">
    <img :src="item.picture" />
    <div class="content" :style="isShow ? 'height:100%;' : 'height:60px;'">
        <div class="head">
          <span class="name text_ellipsis" :title="item.name">{{ item.name }}</span>
          <span class="job text_ellipsis" :title="item.title">{{ item.title }}</span>
        </div>
        <div class="intro">
          {{ item.profile }}
        </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      item: Object
    },
    data() {
      return {
        isShow: false
      }
    }
  }
</script>

<style lang="scss" scoped>
  .portrait_item {
    position:relative;
    overflow:hidden;
    margin-bottom:20px;
    height:200px;
    background-image: linear-gradient(to bottom, #FFFFFF , #B8EDFF);
    margin-bottom:15px;
    > img {
      width:100px;
      height:100px;
      display: block;
      margin: 20px auto 0;
    }
    .content {
      -webkit-transition: all .5s ease;
      transition: all .5s ease;
      background:rgba(0, 157, 217, 0.9);
      position:absolute;
      left:0;
      bottom:0;
      right:0;
      color:#fff;
      height:100%;
      overflow: hidden;
      .head {
        display:flex;
        padding:0 20px;
        height:60px;
        line-height:60px;
        align-items: center;
        > span {
          display:block;
          height:60px;
          &.name {
            font-size:18px;
            font-weight: bold;
            margin-right:20px;
            max-width:50%;
          }
          &.job {
            flex:1;
          }
        }
      }
      .intro {
        padding:0 20px 20px 20px;
        font-size:12px;
        overflow:hidden;
        line-height:2;
        word-wrap: break-word;
        word-break: break-all;
        max-height:140px;
        overflow-x:hidden;
        overflow-y:auto;
      }
    }
  }
</style>
